import { render, staticRenderFns } from "./WorkTypeSearch.vue?vue&type=template&id=88bfeb08&scoped=true&"
import script from "./WorkTypeSearch.vue?vue&type=script&lang=js&"
export * from "./WorkTypeSearch.vue?vue&type=script&lang=js&"
import style0 from "./WorkTypeSearch.vue?vue&type=style&index=0&id=88bfeb08&scoped=true&lang=scss&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "88bfeb08",
  null
  
)

export default component.exports